import { Component } from '@theme/component';
import {
  getConfig, honourURLScope, buildSearchURL, mountVehicleBar,
} from '@theme/buchans-search';

class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];
  #controller;
  #ready;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const form = this.refs.searchPageInput.form;
    this.#ready = getConfig().then((config) => {
      honourURLScope(config);
      if (this.isConnected && form) {
        mountVehicleBar(form, config, () => this.#submit());
      }
      return config;
    });
    this.#ready.catch(() => {});
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.#submit();
    }, { signal });
    form?.addEventListener('click', (event) => {
      const reset = event.target.closest('.search__reset-button');
      if (!reset) return;
      event.preventDefault();
      this.refs.searchPageInput.value = '';
      this.#submit();
    }, { signal });
    document.addEventListener('buchans:search-scope-change', (event) => {
      if (event.detail?.source === form) return;
      getConfig().then((config) => {
        if (this.isConnected && form) mountVehicleBar(form, config, () => this.#submit());
      }).catch(() => {});
    }, { signal });
    window.addEventListener('pageshow', () => {
      getConfig().then((config) => {
        honourURLScope(config, true);
        if (this.isConnected && form) {
          mountVehicleBar(form, config, () => this.#submit());
        }
      }).catch(() => {});
    }, { signal });
  }
  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
  handleKeyDown = (event) => {
    const input = this.refs.searchPageInput;
    if (event.key === 'Enter') {
      event.preventDefault();
      this.#submit();
    }
    if (event.key === 'Escape' && input.value.trim() === '') {
      event.preventDefault();
      this.#submit();
    }
  };
  async #submit() {
    try {
      const config = await getConfig();
      const url = buildSearchURL(config, this.refs.searchPageInput.value);
      location.assign(url.href);
    } catch {
      alert('Vehicle search could not be loaded. Please reload the page and try again.');
    }
  }
}
if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}
